import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// INTERFACES
import { DevTypeOptionInterface } from "../../../interfaces/Adapter.interface";

export default function FormSelectDevType({
  inputValue,
  inputOnChange,
}: {
  inputValue: number;
  inputOnChange: (newValue: number) => void;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;
  const OPTIONS: DevTypeOptionInterface[] = [
    { name: "LV16Input", value: 0 },
    { name: "Hv8Input", value: 1 },
  ];

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="col-md-12 mt-3">
      <div className="generalStyles__flex">
        <div className="generalStyles__inputFlexNameLarge">
          <span className="generalStyles__inputFlexRequired">*</span>
          <span>Dev Type</span>
        </div>
        <div className="generalStyles__width100">
          <Select
            className="generalStyles__width100"
            size="small"
            onChange={(e: any) => {
              inputOnChange(e);
            }}
            value={inputValue}
          >
            {OPTIONS.map((item: DevTypeOptionInterface) => (
              <Option key={item.value} value={item.value}>
                {item.name}
              </Option>
            ))}
          </Select>
        </div>
        <div className="generalStyles__infoTooltipIconBlank" />
      </div>
    </div>
  );
}
